<template>
  <path pid="0" d="M21 6h-8.46l-1.71-2.55A1 1 0 0010 3H5a3 3 0 00-3 3v14a3 3 0 003 3h16a3 3 0 003-3V9a3 3 0 00-3-3zm1 14a1 1 0 01-1 1H5a1 1 0 01-1-1V6a1 1 0 011-1h4.46l1.71 2.55A1 1 0 0012 8h9a1 1 0 011 1z"/>
</template>
